import { checkoutModes, paymentStatuses } from '@/Models';
import Resources from '@/Resources.js';

export function getOrderPaymentStatuses(paymentStatus) {
    return {
        [paymentStatuses.deferredWithError]: Resources.OrderStatus.OrderPaymentStatusPaymentErrorName,
        [paymentStatuses.canceled]: Resources.OrderStatus.OrderPaymentStatusCanceledName,
        [paymentStatuses.completed]: Resources.OrderStatus.OrderPaymentStatusPaidName,
        [paymentStatuses.deferred]: Resources.OrderStatus.OrderPaymentStatusScheduledName,
    }[paymentStatus];
}

export const paymentInfoBoxTypes = {
    pay: 0,
    pledge: 1,
};
// Checkout modes where an existing order is being paid for, rather than only put together.
export const payCheckoutModes = [
    checkoutModes.crowdfundingResumePayment,
    checkoutModes.latePledgeAmendOrder,
    checkoutModes.latePledgeResumePayment,
    checkoutModes.latePledgeCreateOrder,
    checkoutModes.pledgeManagerAmendOrder,
    checkoutModes.pledgeManagerCreateOrder,
    checkoutModes.pledgeManagerResumePayment,
    checkoutModes.pledgeManagerManageShipping,
    checkoutModes.storeCreateOrder,
    checkoutModes.storeResumePayment,
];
